import _extends from "@babel/runtime/helpers/extends";
import styled from "@emotion/styled";
import { lodestarColors } from "@smartsheet/design-tokens";
import React, { forwardRef } from "react";
import { COMPONENT_TOKEN_PREFIX } from "../../../../constants/tokens";
import { Button } from "../../../button";
import { Clickable } from "../../../clickable";
const {
  buttonPrimary,
  buttonPrimaryHover,
  buttonPrimaryPressed
} = lodestarColors;
const componentTokenName = "date--picker--calendar--button";
const componentVarPrefix = `${COMPONENT_TOKEN_PREFIX}${componentTokenName}`;
const DatePickerCalendarButtonBase = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    themeMode,
    ...rest
  } = props;
  if (themeMode.includes("ursa")) {
    return /*#__PURE__*/React.createElement(Button, _extends({}, rest, {
      ref: ref
    }));
  }
  //@ts-expect-error complains about children not being included, but they are spread in the rest.
  return /*#__PURE__*/React.createElement(Clickable, _extends({}, rest, {
    ref: ref
  }));
});
DatePickerCalendarButtonBase.displayName = "DatePickerCalendarButtonBase";
export const DatePickerCalendarButton = styled(DatePickerCalendarButtonBase)`
    &.is-disabled {
        display: none;
    }
    ${_ref => {
  let {
    themeMode
  } = _ref;
  if (themeMode.includes("ursa")) return `
            margin-right: 3px;
            &:focus::before {
                inset: 0px;
                border-radius: 4px;
            }
        `;
  return `
            height: 24px;
            width: 24px;
            display: flex;
        
            color: var(${componentVarPrefix}--color, ${buttonPrimary});//no token available
            &:hover {
                color: var(${componentVarPrefix}--color--hover, ${buttonPrimaryHover});//no token available
            }
            &:active {
                color: var(${componentVarPrefix}--color--active, ${buttonPrimaryPressed});//no token available
            }
        `;
}}
`;
DatePickerCalendarButton.displayName = "DatePickerCalendarButton";
//# sourceMappingURL=DatePickerCalendarButton.js.map